/* eslint-disable no-param-reassign */
import { etpLocales } from 'app/router/constants/routerLocales';

class LocaleInterceptor {
  constructor() {
    this.locale = '';

    this.intercept = this.intercept.bind(this);
  }

  setLocale(locale) {
    this.locale = etpLocales[locale];
  }

  intercept(requestConfig) {
    const { baseURL = '', url = '' } = requestConfig;
    const fullUrl = new URL(baseURL + url);

    if (this.locale && !fullUrl.searchParams.get('locale')) {
      requestConfig.params = requestConfig.params || {};
      requestConfig.params.locale = this.locale;
    }

    return requestConfig;
  }

  getInterceptor() {
    return this.intercept;
  }
}

export default new LocaleInterceptor();
